<template>
  <div class="container-fluid mt--6">
      <div class="row">
        <div class="col-xl-12">
          <div class="card scrollbar vh-75" id="scroll">
            <div class="tabHeader" v-if="offerStatus">
                <h4>Imported Offerings</h4>
                <div class="summary-wrap">
                  <div class="opn-wrap">
                    <a href="#">
                      {{offerStatus.importedOffer}} Offerings<span class="text-dark"></span>
                      <!-- <router-link to="/ims/ims-inventory">  
                        <button type="submit" class="btn btn-dark my-2">GO <i aria-hidden="true" class="fa fa-arrow-circle-right"></i></button>
                      <router-link to="/ims/ims-inventory">   -->
                    </a>
                    </div>
                    <div class="opn-wrap">
                      <a href="#">
                        {{offerStatus.waitingOffer}} Offerings<span>Within Merge Factor</span>                         
                        <!-- <button type="submit" class="btn btn-primary my-2">GO <i aria-hidden="true" class="fa fa-arrow-circle-right"></i></button> -->
                      </a>
                    </div>
                </div>
            </div>
            <div class="innerTab">
              <input v-bind:class="{ 'btn-primary': currentTab == 'alloffer'  }" @click="currentTab = 'alloffer'" class="btn btn-secondary rounded" type="button" value="ALL IMPORTED OFFERING">
              <input v-bind:class="{ 'btn-primary': currentTab == 'offererror' }" @click="currentTab = 'offererror'" class="btn btn-secondary rounded" type="submit" value="ERRORS">   
              <input v-bind:class="{ 'btn-primary': currentTab == 'offermerge' }" @click="currentTab = 'offermerge'" class="btn btn-secondary rounded" type="submit" value="WITHIN MERGE FACTOR">   
              
            </div>    
              <allimportedoffering v-if="currentTab == 'alloffer'" />
              <offeringmerge v-if="currentTab == 'offermerge'" />
              <offererror v-if="currentTab == 'offererror'" />
          </div>
        </div>
      </div>
  </div>       
</template>
<script>
import allimportedoffering from './imsAllImportedOfferings';
import offeringmerge from './ImsOfferingMergefactor';
import offererror from './ImsOfferingError';

import config from "@/config";
import authService from "@/authService";
export default {
  name: "imsimportdata",
  components : {
    allimportedoffering,
    offeringmerge,
    offererror
  },
  data() {
    return {
      currentTab : "alloffer",
      offerStatus : null

    };
  },
  methods: {
    getOfferStatus(){
        const auth = {
            headers: { 'org-token' : authService.getOrgToken() }
        };
        this.$http
        .get(
           config.baseUrlBidSide +
            "/offer/imported-offer-count",
            auth
        )
        .then(result => {
          this.offerStatus = result.data;
        }).catch(() => this.loading = false);
    }
  },
  mounted() {
    this.getOfferStatus()
  }
};
</script>